import { type FC } from "react";

import type { INewsMarker } from "~/feature/chart/types";
import { formatPercentageValue } from "~/utils/formatValue";

import * as Styled from "./NewsMarkerTooltip.styles";

const formatPublishedAt = (publishedAt: string) =>
  new Date(publishedAt).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  });

const formatChange = (value: number) =>
  `${value < 0 ? "" : "+"}${formatPercentageValue(value, { maximumFractionDigits: 1 })}`;

interface INewsMarkerTooltipProps {
  marker: INewsMarker;
}

export const NewsMarkerTooltip: FC<INewsMarkerTooltipProps> = ({ marker }) => {
  const { sentiment, sourceName, publishedAt, title, url, priceChange24h } =
    marker;

  return (
    <Styled.Body>
      <Styled.Row>
        {sentiment && (
          <Styled.SentimentChip $sentiment={sentiment}>
            {sentiment}
          </Styled.SentimentChip>
        )}

        <Styled.Meta>{`${sourceName} · ${formatPublishedAt(publishedAt)}`}</Styled.Meta>
      </Styled.Row>

      <Styled.Title>{title}</Styled.Title>

      <Styled.Row>
        {priceChange24h !== null && (
          <>
            <Styled.Change $isPositive={priceChange24h >= 0}>
              {formatChange(priceChange24h)}
            </Styled.Change>
            <Styled.Caption>24h price change</Styled.Caption>
          </>
        )}

        <Styled.ReadMore href={url} target="_blank" rel="noopener noreferrer">
          Read more →
        </Styled.ReadMore>
      </Styled.Row>
    </Styled.Body>
  );
};
